<mat-list avatar disableRipple>
  <mat-list-item
    *ngFor="let item of items; trackBy: trackBy"
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
    [class.active]="selected === item.name"
    [@snFadeIn]
    [@snFadeOut]
  >
    <sn-avatar matListIcon [name]="item.name" [bgColor]="item.color" [size]="24"> </sn-avatar>
    <div class="call-sign-container">
      <span class="call-sign-name">{{ item.name }}</span>
      <fs-call-sign-list [items]="item.callSigns"></fs-call-sign-list>
    </div>
    <sn-action-list alwaysExpand [items]="actions" [context]="item"> </sn-action-list>
  </mat-list-item>
</mat-list>
